import React, {useEffect, useState} from "react";
import "./_format-tile.scss";
import SVG from 'react-inlinesvg';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../../../../store/configureStore';
import {clubFinderSearchBarSliceActions} from "../../../../../store/slices/clubFinderSearchBarSlice";
import {Config} from "../../../../../constants/Config";

const baseClass = 'clubFinder-formatTile'

interface FormatTileTypes {
  formatTitle: any
  formatLogo: string | null
  formatLogoStyles?: string
  setSelectedFormat?: any
  playHqFormats?: any
  removeSelectedFormat?: any
}

const FormatTile = (props: FormatTileTypes): JSX.Element => {
  const dispatch = useDispatch();
  const [formatSelected, setSelectedFormat] = useState(false)
  const savedFormatFilterName: any = useSelector((state: RootState) => state.clubFinderSearchBarStore.selectedFormatFilterName)


  useEffect(() => {
    if (savedFormatFilterName && savedFormatFilterName.length > 0) {
      for (let i = 0; i < savedFormatFilterName.length; i++) {
        if (savedFormatFilterName[i].replace(/ /g, "_") === props.formatTitle.replace(/ /g, "_")) {
          setSelectedFormat(true);
        }
      }
    }
  }, [savedFormatFilterName, props.playHqFormats, props.formatTitle])

  const handleFormatSelection = () => {
    setSelectedFormat(!formatSelected);

    if (formatSelected) {
      if (props.formatTitle.replace(/ /g, "_") === Config.defaultFormatOption.name.replace(/ /g, "_")) {
        dispatch(clubFinderSearchBarSliceActions.setSavedFormatFilter({selectedFormatObject: null, selectedFormatTitles: null}))
      }
      props.removeSelectedFormat(props.playHqFormats, props.formatTitle)
    } else {
      props.setSelectedFormat(props.playHqFormats, props.formatTitle);
    }
  }

  return (
    <div className={`${baseClass} ${baseClass}--format-selected-${formatSelected}`} onClick={handleFormatSelection}>
      <div className={`${baseClass}--tile-content`}>
        <div className={`${baseClass}--logo-container`}>
          {props.formatLogo && (
            <SVG
              src={props.formatLogo}
              width={128}
              height={'100%'}
              title="React"
              className={`${baseClass}--format-logo ${props.formatLogoStyles}`}
            />
          )}
        </div>
        <div className={`${baseClass}--format-title`}>
          {props.formatTitle}
        </div>
      </div>
    </div>
  )
}

export default FormatTile;
